<template lang="pug">
b-modal#editPackage(
  ref="editPackage"
  :title="$t('ui.combine.edit_package')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  size="lg"
  @ok="done"
  @show="reset"
  @shown="shown")
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    .row
      .col-6
        b-form-group(:label="$tc('ui.name')").mb-1
          MultipleNameInputs(
            v-model="multiNameData"
            ref="MultipleNameInputs"
            :name="packageTypeName"
            fieldName="name"
          )
      .col-6
        b-form-group(:label="$t('ui.package_type')").mb-1
          DebounceInput(
            size="sm"
            ref="package_type"
            required
            type="text"
            :dirty="$v.package_type.$dirty"
            :error="$v.package_type.$error"
            v-model.trim.lazy="$v.package_type.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.package_type" :name="$t('ui.package_type')")
        b-form-group(:label="$t('ui.package_level')").mb-1
          b-form-select.text-uppercase(
            v-model.trim.lazy="$v.package_level.$model"
            size="sm"
            :dirty="$v.package_level.$dirty"
            :error="$v.package_level.$error"
            :disabled="loading"
            :class="{ 'is-invalid': $v.package_level.$dirty && $v.package_level.$error, 'is-valid': $v.package_level.$dirty && !$v.package_level.$error }"
            )
            option(value="" disabled selected) {{ $t("message.select_option") }}
            option(value="1") 1
            option(value="2") 2
            option(value="3") 3
            option(value="4") 4
            option(value="5") 5
            option(value="6") 6
          ValidateResult(:value="$v.package_level" :name="$t('ui.package_level')")
        b-form-group(:label="$t('ui.price')").mb-1
          DebounceInput(
            size="sm"
            ref="price"
            required
            type="number"
            :min="min"
            :max="max"
            :dirty="$v.price.$dirty"
            :error="$v.price.$error"
            v-model.trim.lazy="$v.price.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.price" :name="$t('ui.price')")
        b-form-group(:label="$t('ui.bo_right')").mb-1
          b-form-select.text-uppercase(
            v-model="bo_right"
            size="sm"
            :dirty="$v.bo_right.$dirty"
            :error="$v.bo_right.$error"
            :disabled="loading"
            :class="{ 'is-invalid': $v.bo_right.$dirty && $v.bo_right.$error, 'is-valid': $v.bo_right.$dirty && !$v.bo_right.$error }"
            )
            option(value="" disabled selected) {{ $t("message.select_option") }}
            option(value=1) {{ $t("ui.full_back_office_access_right") }}
            option(value=2) {{ $t("ui.read_only_back_office") }}
          ValidateResult(:value="$v.bo_right" :name="$t('ui.bo_right')")
        b-form-group(:label="$t('ui.sequence')").mb-1
          DebounceInput(
            size="sm"
            ref="sequence"
            required
            type="number"
            :min="min"
            :max="max"
            :dirty="$v.sequence.$dirty"
            :error="$v.sequence.$error"
            v-model.trim.lazy="$v.sequence.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.sequence" :name="$t('ui.sequence')")
        b-form-group(:label="$t('ui.remark')").mb-1
          DebounceInput(
            size="sm"
            ref="remark"
            required
            type="text"
            :dirty="$v.remark.$dirty"
            :error="$v.remark.$error"
            v-model.trim.lazy="$v.remark.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.remark" :name="$t('ui.remark')")
        //- b-form-group(:label="$t('ui.status')").mb-1
        //-   b-form-select.text-uppercase(
        //-     disabled
        //-     v-model="package_status"
        //-     size="sm"
        //-     :dirty="$v.package_status.$dirty"
        //-     :error="$v.package_status.$error"
        //-     :class="{ 'is-invalid': $v.package_status.$dirty && $v.package_status.$error, 'is-valid': $v.package_status.$dirty && !$v.package_status.$error }"
        //-     )
        //-     option(value="" disabled selected) {{ $t("message.select_option") }}
        //-     option(value="ACTIVE") {{ $t("ui.active") }}
        //-     option(value="INACTIVE") {{ $t("ui.inactive") }}
        //-   ValidateResult(:value="$v.package_status" :name="$t('ui.status')")

    .row
      .col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.close')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, minValue, maxValue, minLength, maxLength } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import MultipleNameInputs from "@/library/MultipleNameInputs";
import config from "@/config";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    MultipleNameInputs
  },
  props: {
    item: {
      type: Object
    }
  },
  data() {
    return {
      package_id: '',
      bo_right: '',
      price: '',
      package_type: '',
      multiNameData: [],
      packageTypeName: {},
      nameError: false,
      sequence: '',
      remark: '',
      package_level: '',
      // package_status: '',
      min: 1,
      max: 999999999,
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  validations: {
    package_type: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(10),
      noSpace: function(value) {
        const regexp = /^\S*$/.test(value);
        return regexp
      }
    },
    price: {
      required,
      minValue: minValue(1),
      maxValue: maxValue(999999999)
    },
    sequence: {
      required,
      minValue: minValue(0),
      maxValue: maxValue(999999999)
    },
    bo_right: {
      required,
    },
    package_level: {
      required
    },
    // package_status: {
    //   required
    // },
    remark: {
      minLength: minLength(2),
      maxLength: maxLength(500)
    }
  },
  methods: {
    done(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit() {
      this.$refs.MultipleNameInputs.validationCheck();
      this.$v.$touch();
      this.nameError = this.multiNameData.vError;

      if (!this.nameError && !this.$v.$invalid) {
        let url = config.editPackageUrl();
        var json = {
          auth_token: this.$store.getters.sessionToken,
          action_by: this.$store.getters.loginId,
          package_id: this.package_id,
          package_type: this.package_type,
          package_desc_en: this.multiNameData.en,
          package_desc_cn: this.multiNameData.cn,
          package_desc_tw: this.multiNameData.tw,
          package_desc_ph: this.multiNameData.ph,
          package_desc_th: this.multiNameData.th,
          package_desc_vi: this.multiNameData.vi,
          package_desc_id: this.multiNameData.id,
          package_desc_my: this.multiNameData.my,
          package_desc_jp: this.multiNameData.jp,
          package_desc_kr: this.multiNameData.kr,
          // renew_term: this.renew_term,
          package_price: this.price,
          bo_right: this.bo_right,
          remark: this.remark,
          sequence: this.sequence,
          package_level: this.package_level,
          // package_status: this.package_status,
          package_status: this.item.status,
          domain_count: 0,
          provider_count: 0,
          payment_count: 0,
          renew_term: 12
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = (typeof response.data.status == "string") ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "edit_package", this.feedback.status);
                }
                this.$nextTick(() => {
                  this.$refs.editPackage.hide();
                });
              }
            } catch (error) {
              this.loading = false;
              if (error.status.toLowerCase() == "nochanges") {
                this.$emit("clicked");
                this.$nextTick(() => {
                  this.$refs.editPackage.hide();
                });
              } else {
                this.feedback.success = false;
                this.feedback.status = error.status;
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = response.data.status;
            this.$helpers.handleFeedback(this.feedback.status);
          }
        );
      }
    },
    reset() {
      this.feedback.success = true;
      this.feedback.status = "";
      this.package_id = "";
      this.price = "";
      this.package_type = "";
      this.multiNameData = [];
      this.nameError = false;
      this.bo_right = "";
      this.sequence = "";
      this.remark = "";
      this.package_level = ""
      // this.package_status = ""
      var vm = this
      $(document).ready(function() {
        vm.$refs.MultipleNameInputs.reset();
      });
    },
    shown() {
      this.$v.$reset();
      this.package_id = this.item.package_id;
      this.price = this.item.package_price;
      var vm = this
      $(document).ready(function() {
        vm.packageTypeName = {
          en: vm.item.package_desc_en,
          cn: vm.item.package_desc_cn,
          tw: vm.item.package_desc_tw,
          ph: vm.item.package_desc_ph,
          th: vm.item.package_desc_th,
          vi: vm.item.package_desc_vi,
          id: vm.item.package_desc_id,
          my: vm.item.package_desc_my,
          jp: vm.item.package_desc_jp,
          kr: vm.item.package_desc_kr,
          disable_en: true
        }
      });
      this.bo_right = this.item.bo_right;
      this.sequence = this.item.sequence;
      this.remark = this.item.remark;
      this.package_level = this.item.package_level;
      // this.package_status = this.item.status
      this.package_type = this.item.package_type
      this.$refs.MultipleNameInputs.focusInput();
    }
  }
};
</script>
